import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/avatar.svg
 */
const IconAvatar: IconComponent = ({
  size = 24,
  color = '#5D595C',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12 0a11.99 11.99 0 00-8.238 20.71 9.96 9.96 0 0116.475 0A11.99 11.99 0 0012 0zm0 13.684a4.955 4.955 0 110-9.91 4.955 4.955 0 010 9.91z"
      fill="currentColor"
    />
  </svg>
);

export default IconAvatar;
